import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PageHeader } from '../../../components/ui/PageHeader'

interface Etapa {
  id: string
  titulo: string
  subtitulo: string
  pasta: string
  fotos: string[]
}

// Lista de etapas com fotos disponiveis (estaticas servidas pelo nginx em /galeria/...)
const ETAPAS_FOTOS: Etapa[] = [
  {
    id: 'etapa-1',
    titulo: '1a Etapa - 2026',
    subtitulo: 'Campeonato Municipal Interclube',
    pasta: '/galeria/etapa-1',
    fotos: ['foto-01.jpg', 'foto-02.jpg', 'foto-03.jpg', 'foto-04.jpg', 'foto-05.jpg', 'foto-06.jpg'],
  },
]

export function GaleriaPage() {
  const navigate = useNavigate()
  const [lightbox, setLightbox] = useState<{ src: string; etapa: Etapa; idx: number } | null>(null)

  function nextLightbox() {
    if (!lightbox) return
    const total = lightbox.etapa.fotos.length
    const next = (lightbox.idx + 1) % total
    setLightbox({ ...lightbox, idx: next, src: `${lightbox.etapa.pasta}/${lightbox.etapa.fotos[next]}` })
  }
  function prevLightbox() {
    if (!lightbox) return
    const total = lightbox.etapa.fotos.length
    const prev = (lightbox.idx - 1 + total) % total
    setLightbox({ ...lightbox, idx: prev, src: `${lightbox.etapa.pasta}/${lightbox.etapa.fotos[prev]}` })
  }

  return (
    <div className="space-y-4">
      <PageHeader title="Galeria de Fotos e Videos" description="Momentos das etapas do campeonato" />

      {ETAPAS_FOTOS.map(etapa => (
        <div key={etapa.id} className="bg-compumaq-pretoSuave rounded-xl border border-compumaq-dourado/25 shadow-sm overflow-hidden">
          <div className="bg-gradient-to-r from-compumaq-dourado/10 to-amber-50 border-b border-compumaq-dourado/25 px-4 py-3">
            <h2 className="font-semibold text-compumaq-texto">{etapa.titulo}</h2>
            <p className="text-xs text-compumaq-textoSuave">{etapa.subtitulo} — {etapa.fotos.length} fotos</p>
          </div>

          <div className="p-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
            {etapa.fotos.map((arquivo, idx) => {
              const src = `${etapa.pasta}/${arquivo}`
              return (
                <button
                  key={arquivo}
                  type="button"
                  onClick={() => setLightbox({ src, etapa, idx })}
                  className="aspect-[3/4] bg-compumaq-pretoSuave rounded-lg overflow-hidden hover:ring-2 hover:ring-compumaq-dourado transition group"
                >
                  <img
                    src={src}
                    alt={`Foto ${idx + 1} - ${etapa.titulo}`}
                    className="w-full h-full object-cover group-hover:scale-105 transition"
                    loading="lazy"
                  />
                </button>
              )
            })}
          </div>
        </div>
      ))}

      {/* Lightbox */}
      {lightbox && (
        <div className="fixed inset-0 bg-black z-50 flex items-center justify-center" onClick={() => setLightbox(null)}>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); prevLightbox() }}
            className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-compumaq-pretoSuave/20 hover:bg-compumaq-pretoSuave/40 text-white text-2xl flex items-center justify-center"
            aria-label="Anterior"
          >
            ‹
          </button>

          <img
            src={lightbox.src}
            alt=""
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />

          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); nextLightbox() }}
            className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-compumaq-pretoSuave/20 hover:bg-compumaq-pretoSuave/40 text-white text-2xl flex items-center justify-center"
            aria-label="Proxima"
          >
            ›
          </button>

          <button
            type="button"
            onClick={() => setLightbox(null)}
            className="absolute top-3 right-3 px-3 py-1.5 bg-compumaq-pretoSuave/20 hover:bg-compumaq-pretoSuave/40 text-white rounded-lg text-sm"
          >
            Fechar
          </button>

          <div className="absolute bottom-4 left-0 right-0 text-center text-white text-sm">
            {lightbox.idx + 1} / {lightbox.etapa.fotos.length} — {lightbox.etapa.titulo}
          </div>
        </div>
      )}

      <div className="text-center pt-4">
        <button onClick={() => navigate('/dashboard')} className="text-sm text-compumaq-doradoClaro hover:text-compumaq-doradoClaro">
          ← Voltar para o painel
        </button>
      </div>
    </div>
  )
}
